/* unplugin-vue-components disabled */
export default {
  props: {
    chatId: {type: String, required: true},
    data: {type: Object, required: true},
    mode: {type: String, required: true},
    disabled: {type: Boolean, default: false}
  },
  data(){
    return {
      tooltip_visible: false
    }
  },
  computed: {
    text() {
      return this.data.text
    },
    c_icon () {
      return this.mode === 'compact' ? 'white' : 'var(--error-600)'
    }
  },
  methods: {
    async onCopy(){
      await $utils.copyText($utils.format.json({
        host: window.location.host,
        chat_id: this.chatId,
        ...this.data
      }))
      
      this.tooltip_visible = true
      await $utils.timers.wait(3000)
      this.tooltip_visible = false
    },
  }
}
